import React from 'react'
import { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { envAwarePost } from '../../../util/util'
import { updateComments,createEventCommment } from '../../../state/events'
import { useEvent } from '../../../hooks/events'
import useCurrentUser from '../../../hooks/useCurrentUser'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import styles from './EventComments.module.css'
import Spinner from "react-bootstrap/Spinner"
import Moment from 'react-moment'

const EventComments = () => {
	const user = useCurrentUser()
	const dispatch = useDispatch()
	const commentsRef = useRef()
	const [status, setStatus] = useState('idle')
	const [newComment, setNewComment] = useState('')
	const { id, type, show } = useSelector(state => state.allEvents.comments)
	const event = useEvent(type, id)
	const client_id = event?.client_id
	const comments = event?.comments
	// console.log(client_id)

	//auto scroll to bottom when new comments get added
	useEffect(() => {
		if (!commentsRef.current) return
		commentsRef.current.scrollTop = commentsRef.current.scrollHeight
	}, [comments])

	//some handlers
	const handleClose = () => {
		dispatch(updateComments({ show: false }))
	}

	const handleAddComment = () => {
		setStatus('pending')
		dispatch(createEventCommment({
			comment:newComment,
			event_type:type,
			event_id:id
		})).then(res=>{
			setNewComment('')
			setStatus('idle')
		})

	}

	if(!comments) return null

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Comments</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div ref={commentsRef} style={{ maxHeight: '400px', overflow: 'auto' }}>
					<div>
						{comments.map(comment => (
								<div className={
									parseInt(user.user_id_number) === parseInt(comment.author_id)
									? styles.Right 
									: styles.Left
								}>
									<div className={styles.Comment}>
										<small>{comment.from}
											<Moment format="MMM DD, YYYY @ hh:mm A">
												{new Date(comment.datetime).toLocaleString()}
											</Moment></small>
										<div>{comment.comment} </div>
									</div>
								</div>
						))}
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Form.Control
					onChange={e => {
						setNewComment(e.target.value)
					}}
					placeholder="new comment..."
					value={newComment}
					as="textarea"
				/>
				<Button onClick={handleAddComment} size="sm" variant="success" disabled={!newComment||status==='pending'}>
					Add Comment
					{status === 'pending' && <Spinner className="ml-1" animation="border" role="status" size="sm">
						<span className="sr-only">Loading...</span>
					</Spinner>}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EventComments